// extracted by mini-css-extract-plugin
export default {"headerTag":"tag_headerTag__k+mtk","tagStyle":"tag_tagStyle__JkX86"};